import { createNode } from '@glueapp/graph-types';

export const GetLengthOfList = createNode({
    id: 'Get Length Of List',
    name: 'Get Length Of List',
    description: 'Gets the number of elements in the list',
    aiDescription: 'Returns the number of elements in a list. Connect a list to "List". Output: "Output" (number).',
    category: 'List',
    color: '#778ed5',
    integration: undefined,
    inPorts: {
        List: {
            kind: 'array',
            subType: {
                kind: 'generic',
                identifier: 'T',
            },
        },
    },
    outPorts: {
        Output: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.List.length } };
    },
});
